<template>
  <div v-if="page">
    <page-banner
      :title="page.banner.title"
      :text="page.banner.text"
      :colour="page.banner.colour"
    />
    <div class="grid-x align-center">
      <div class="cell small-11 medium-8">
        <v-content :blocks="page.content"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import VContent from '@/components/content/Content.vue';
  import PageBanner from '@/components/PageBanner.vue';

  export default {
    metaInfo() {
      return {
        title: 'Standards'
      }
    },
    props: {
      homeSlug: String,
      slug: String
    },
    components: {
      VContent,
      PageBanner
    },
    mounted() {
      this.fetchPage('standards')
    },
    methods: {
      ...mapActions(['fetchPage'])
    },
    computed: {
      page() {
        return this.$store.getters.getPage('standards');
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .title {
    &.-t1 {
      margin: .8em 0 .6em;
    }
    &.-t4 {
      margin-bottom: 2em;
    }
  }
</style>
